<template>
  <div>
    <b-modal
      ref="modal"
      header-class="border-bottom-0"
      size="lg"
      hide-header
      no-close-on-backdrop
    >
      <div class="row">
        <div class="col-md-12">
          <h5 class="text-primary">
            <i class="fas fa-exclamation-triangle mr-2" />Inutilizar Notas
            Fiscais
          </h5>
        </div>
      </div>
      <br />

      <b-row>
        <b-col>
          <text-input v-model="form.mod.value" :alias="form.mod.alias" /></b-col
        ><b-col>
          <text-input v-model="form.nSerie.value" :alias="form.nSerie.alias" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <text-input
            v-model="form.nIni.value"
            :alias="form.nIni.alias" /></b-col
        ><b-col>
          <text-input v-model="form.nFin.value" :alias="form.nFin.alias" />
        </b-col>
      </b-row>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <b-form-group :label="form.xJust.alias">
              <textarea
                :label="form.xJust.alias"
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
                v-model="form.xJust.value"
                placeholder="Erro de digitação dos Produtos"
              />
            </b-form-group>
          </div>
        </div>
      </div>
      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Voltar
        </button>
        <button
          role="button"
          class="btn btn-danger"
          style="margin-left: 5px"
          @click="disableNfeRangeSefaz()"
        >
          <i class="fas fa-check"></i> Enviar inutilização
        </button>
      </div>
      <error-handler :error="error" />
      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
        >{{ alertData.message }}</b-alert
      >
    </b-modal>
  </div>
</template>

<script>
import Form from "../../../mixins/Form";

export default {
  data: function () {
    return {
      form: new Form({
        mod: { validate: { required: true }, alias: "Modelo" },
        nSerie: { validate: { required: true }, alias: "Série" },
        nIni: { validate: { required: true }, alias: "Número Inicial" },
        nFin: { validate: { required: true }, alias: "Número Final" },
        xJust: {
          validate: { required: true },
          alias: "Justificativa (Minimo 15 carácteres)",
        },
      }),

      error: null,

      alertData: {
        isVisible: false,
        message: null,
      },
    };
  },

  methods: {
    open() {
      this.$refs.modal.show();
    },

    disableNfeRangeSefaz() {
      if (this.isFormValid()) {
        this.$store.commit("showLoading");

        axios
          .post("api/nfe/disable", this.form.getValues())
          .then((response) => {
            this.$store.commit({
              type: "showAlert",
              message: response.data,
              variant: "success",
            });
            this.$store.commit("hideLoading");
            this.$emit("stored");
            this.$refs.modal.hide();
          })
          .catch((error) => {
            this.$store.commit("hideLoading");
            this.error = error;
          });
      }
    },

    resetForm() {
      this.error = null;

      this.alertData.isVisible = false;

      this.form.reset();
    },

    isFormValid() {
      if (!this.form.isValid()) {
        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;

        return false;
      }

      return true;
    },
  },
};
</script>

<style>
</style>

